import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a calendar days icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/calendar-days?f=classic&s=solid
 */
export const CalendarDaysIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCalendarDays} {...props} />;
};
